export default function NewGames(props) {
  const { fill = '#051828' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={30} height={28.541} {...props}>
      <path
        data-name="Icon material-new-releases"
        d="m30 14.264-3.327-3.791.464-5.018-4.923-1.119L19.636 0 15 1.99 10.364 0 7.786 4.336l-4.923 1.1.464 5.018L0 14.264l3.327 3.791-.463 5.035 4.923 1.118 2.577 4.336 4.636-2 4.636 1.991 2.578-4.345 4.923-1.118-.464-5.018Zm-13.636 6.818h-2.728v-2.727h2.727Zm0-5.455h-2.728V7.445h2.727Z"
        fill={fill}
      />
    </svg>
  );
}
